/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserFlagsModeratorControllerFindManyQueryResponse,
  UserFlagsModeratorControllerFindManyQueryParams,
  UserFlagsModeratorControllerFindMany401,
} from '../types/UserFlagsModeratorControllerFindMany.ts';

function getUserFlagsModeratorFindManyUrl() {
  const res = { method: 'GET', url: `/api/moderator/user-flags` as const };
  return res;
}

/**
 * {@link /api/moderator/user-flags}
 */
export async function userFlagsModeratorFindMany(
  params?: UserFlagsModeratorControllerFindManyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    UserFlagsModeratorControllerFindManyQueryResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerFindMany401>,
    unknown
  >({ method: 'GET', url: getUserFlagsModeratorFindManyUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
